webpackJsonp([259485498900132],{

/***/ 487:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Starter Blog","author":"Kyle Mathews"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/2017-11-18-wod/index.md absPath of file >>> MarkdownRemark","html":"<h2>Saturday 11/18</h2>\n<p>For time:</p>\n<p>Run a 5K</p>","frontmatter":{"title":"WOD 11.18.2017","date":"November 18, 2017"}}},"pathContext":{"path":"/wod-2017-11-18/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---wod-2017-11-18-20c988b61f69127cdb86.js